import config from '../config';
import { request } from '../utils/request';

const flowDomain = `${config.host}${config.apiRouter.flow}`;

const api = {
  // 创建
  create_flow (data) {
    return request.post(`${flowDomain}/CreateFlow`, data);
  },

  // 删除
  delete_flow (data) {
    return request.post(`${flowDomain}/UpFlow`, data);
  },

  // 获取列表
  get_flow_list (data) {
    return request.post(`${flowDomain}/GetFlows`, data);
  },
};
export default api;
